import { render, staticRenderFns } from "./LibraryUpdateGenres.vue?vue&type=template&id=219b7c36&scoped=true&"
import script from "./LibraryUpdateGenres.vue?vue&type=script&lang=js&"
export * from "./LibraryUpdateGenres.vue?vue&type=script&lang=js&"
import style0 from "./LibraryUpdateGenres.vue?vue&type=style&index=0&id=219b7c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219b7c36",
  null
  
)

export default component.exports